import React, {useState} from 'react';
import {ServicioOfrecido} from './ServicioOfrecido';

export const ServiciosOfrecidosTipo = () => {
	/* Creating a state variable called Estados and setting it to an array of strings. */
	const [Estados, setEstados] = useState([
		'servicioOfrecido',
		'servicioOfrecido',
		'servicioOfrecido',
		'servicioOfrecido',
		'servicioOfrecido',
		'servicioOfrecido',
	]);

	/**
	 * It takes a number as an argument, then it creates a copy of the state array, then it checks if
	 * the value of the array at the index of the number is equal to "servicioOfrecido", if it is, it
	 * changes the value to "servicioOfrecidoActive", if it isn't, it changes the value to
	 * "servicioOfrecido"
	 */
	const cambiaEstado = (num) => {
		let listaAxu = Estados;
		listaAxu[num] === 'servicioOfrecido'
			? (listaAxu[num] = 'servicioOfrecidoActive')
			: (listaAxu[num] = 'servicioOfrecido');
		setEstados(listaAxu);
	};

	return (
		<div className='contentServiciosOfrecidosTipo'>
			<ServicioOfrecido
				nombreServicio='Cuidado de personas'
				fotoServicio='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.1YJChqEI92OBjzGnN0opUgHaE8%26pid%3DApi&f=1'
				descripCionServicio='Ayudar con las actividades diarias como bañarse, vestirse y moverse.'
				precioServicio='12 - 35€/h'
				cambiaEstado={cambiaEstado}
				num='0'
			/>
			<ServicioOfrecido
				nombreServicio='Cuidado de acompañante'
				fotoServicio='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%3Fid%3DOIP.7lwat8woyweh59CYg6R0dwHaE8%26pid%3DApi&f=1'
				descripCionServicio='Apoyar la interacción social con un acompañante, que también puede acompañarlo a las citas.'
				precioServicio='12 - 35€/h'
				cambiaEstado={cambiaEstado}
				num='1'
			/>
			<ServicioOfrecido
				nombreServicio='Soporte a domicilio'
				fotoServicio='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.BmLRHyLTWlRUMVPw8P570AHaE8%26pid%3DApi&f=1'
				descripCionServicio='Tareas domésticas ligeras, preparación de comidas, platos, recoger medicamentos y otros recados.'
				precioServicio='12 - 35€/h'
				cambiaEstado={cambiaEstado}
				num='2'
			/>
			<ServicioOfrecido
				nombreServicio='Enfermería'
				fotoServicio='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.9kR6-PNtuBiPz29pKN9scQHaE8%26pid%3DApi&f=1'
				descripCionServicio='Tareas de enfermería complejas como monitoreo de signos vitales, terapia intravenosa, extracciones de laboratorio, inyecciones, alimentación por sonda, etc.'
				precioServicio='12 - 35€/h'
				cambiaEstado={cambiaEstado}
				num='3'
			/>
			<ServicioOfrecido
				nombreServicio='Vivir bajo cuidados'
				fotoServicio='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.GkVaj74_8lQ0sRtR80N-HwHaFE%26pid%3DApi&f=1'
				descripCionServicio='Atención las 24 horas a pacientes que requieren atención durante el día y la noche.'
				precioServicio='12 - 35€/h'
				cambiaEstado={cambiaEstado}
				num='4'
			/>
			<ServicioOfrecido
				nombreServicio='Cuidado de relevo'
				fotoServicio='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.-hY4Qh-zHltMlWPWe-TCTgHaE8%26pid%3DApi&f=1'
				descripCionServicio='Cuidado temporal por un corto período de tiempo específico para que los miembros de la familia que cuidan a un paciente puedan tomar un descanso.'
				precioServicio='12 - 35€/h'
				cambiaEstado={cambiaEstado}
				num='5'
			/>
		</div>
	);
};
